/* Margot native cart drawer — functional replica of UpCart "Ivory Cart" (V2). No external app required. */
(function () {
  'use strict';
  if (window.MargotCart) return;

  var root = document.getElementById('mg-cart');
  var cfgEl = document.getElementById('mg-cart-config');
  if (!root || !cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  /* Liquid's t filter HTML-escapes apostrophes etc.; decode plain-text strings */
  var _dec = document.createElement('textarea');
  function decode(s) { _dec.innerHTML = String(s == null ? '' : s); return _dec.value; }
  Object.keys(cfg.t || {}).forEach(function (k) { cfg.t[k] = decode(cfg.t[k]); });
  if (cfg.rw) cfg.rw.label = decode(cfg.rw.label);
  if (cfg.up) cfg.up.addText = decode(cfg.up.addText);

  var _fetch = window.fetch.bind(window);
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SOURCE = 'mg-cart';
  var cart = cfg.cart || { items: [], item_count: 0, total_price: 0, original_total_price: 0, currency: 'BRL' };
  var recCache = {};
  var upsells = [];
  var upIndex = 0;
  var busy = false;
  var lastFocus = null;

  var panel = root.querySelector('.mgc__panel');
  var view = root.querySelector('[data-mgc-view]');

  var ICON = {
    close: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="m11.414 10 6.293-6.293a1 1 0 1 0-1.414-1.414l-6.293 6.293-6.293-6.293a1 1 0 0 0-1.414 1.414l6.293 6.293-6.293 6.293a1 1 0 1 0 1.414 1.414l6.293-6.293 6.293 6.293a.998.998 0 0 0 1.707-.707.999.999 0 0 0-.293-.707l-6.293-6.293z"/></svg>',
    minus: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path fill-rule="evenodd" d="M5 10c0-.414.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75h-8.5c-.414 0-.75-.336-.75-.75Z"/></svg>',
    plus: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path d="M10.75 5.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.5h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.5v-3.5Z"/></svg>',
    trash: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path d="M11.5 8.25a.75.75 0 0 1 .75.75v4.25a.75.75 0 0 1-1.5 0v-4.25a.75.75 0 0 1 .75-.75Z"/><path d="M9.25 9a.75.75 0 0 0-1.5 0v4.25a.75.75 0 0 0 1.5 0v-4.25Z"/><path fill-rule="evenodd" d="M7.25 5.25a2.75 2.75 0 0 1 5.5 0h3a.75.75 0 0 1 0 1.5h-.75v5.45c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327h-.4c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311c-.327-.642-.327-1.482-.327-3.162v-5.45h-.75a.75.75 0 0 1 0-1.5h3Zm1.5 0a1.25 1.25 0 1 1 2.5 0h-2.5Zm-2.25 1.5h7v5.45c0 .865-.001 1.423-.036 1.848-.033.408-.09.559-.128.633a1.5 1.5 0 0 1-.655.655c-.074.038-.225.095-.633.128-.425.035-.983.036-1.848.036h-.4c-.865 0-1.423-.001-1.848-.036-.408-.033-.559-.09-.633-.128a1.5 1.5 0 0 1-.656-.655c-.037-.074-.094-.225-.127-.633-.035-.425-.036-.983-.036-1.848v-5.45Z"/></svg>',
    gift: '<svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M7.835 9.5h-.96c-.343 0-.625-.28-.625-.628 0-.344.28-.622.619-.622.242 0 .463.142.563.363l.403.887Z"/><path d="M10.665 9.5h.96c.343 0 .625-.28.625-.628 0-.344-.28-.622-.619-.622-.242 0-.463.142-.563.363l-.403.887Z"/><path fill-rule="evenodd" d="M8.5 4h-3.25c-1.519 0-2.75 1.231-2.75 2.75v2.25h1.25c.414 0 .75.336.75.75s-.336.75-.75.75h-1.25v2.75c0 1.519 1.231 2.75 2.75 2.75h3.441c-.119-.133-.191-.308-.191-.5v-2c0-.414.336-.75.75-.75s.75.336.75.75v2c0 .192-.072.367-.191.5h4.941c1.519 0 2.75-1.231 2.75-2.75v-2.75h-2.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2.75v-2.25c0-1.519-1.231-2.75-2.75-2.75h-4.75v2.25c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-2.25Zm.297 3.992c-.343-.756-1.097-1.242-1.928-1.242-1.173 0-2.119.954-2.119 2.122 0 1.171.95 2.128 2.125 2.128h.858c-.595.51-1.256.924-1.84 1.008-.41.058-.694.438-.635.848.058.41.438.695.848.636 1.11-.158 2.128-.919 2.803-1.53.121-.11.235-.217.341-.322.106.105.22.213.34.322.676.611 1.693 1.372 2.804 1.53.41.059.79-.226.848-.636.059-.41-.226-.79-.636-.848-.583-.084-1.244-.498-1.839-1.008h.858c1.176 0 2.125-.957 2.125-2.128 0-1.168-.946-2.122-2.119-2.122-.83 0-1.585.486-1.928 1.242l-.453.996-.453-.996Z"/></svg>',
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>'
  };

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || cfg.moneyFormat || '{{amount}}';
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var num = (n / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ', ',');
        default: return fmt(cents, 2);
      }
    });
  }

  /* Same formatter the UpCart custom subtotal block used */
  function formatSubtotal(c, cur) {
    try {
      return new Intl.NumberFormat(cur && cur !== 'BRL' ? 'en-US' : 'pt-BR', {
        style: 'currency', currency: cur || 'BRL', currencyDisplay: 'narrowSymbol'
      }).format(c / 100);
    } catch (e) {
      return 'R$ ' + (c / 100).toFixed(2).replace('.', ',');
    }
  }

  function isZeroPrice(text) {
    var d = String(text || '').replace(/\D/g, '');
    return d.length > 0 && /^0+$/.test(d);
  }

  function imgUrl(src, width) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function itemCount() {
    var n = 0;
    (cart.items || []).forEach(function (i) { n += i.quantity || 0; });
    return n;
  }

  function api(path, body) {
    var opts = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
    return _fetch(ROOT + path, opts).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw j;
        return j;
      });
    });
  }

  function notifyTheme() {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: SOURCE, data: { source: SOURCE, itemCount: cart.item_count } }
      }));
    } catch (e) {}
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(cart.item_count), timestamp: Date.now() }));
    } catch (e) {}
  }

  /* ---------- rendering ---------- */
  function renderHeader() {
    var title = String(cfg.t.title || '').replace(/\{\{\s*cart_quantity\s*\}\}|\[cart_quantity\]/g, cart.item_count);
    return '<div class="mgc__header">' +
      '<span class="mgc__title" id="mgc-title">' + esc(title) + '</span>' +
      '<button type="button" class="mgc__close" data-mgc-close aria-label="' + esc(cfg.t.close) + '">' + ICON.close + '</button>' +
      '</div>';
  }

  function renderAnnouncement() {
    if (!cfg.ann.show || !cfg.ann.text) return '';
    return '<div class="mgc__ann"><p>' + cfg.ann.text + '</p></div>';
  }

  function renderRewards(empty) {
    var rw = cfg.rw;
    if (!rw.show) return '';
    if (empty && !rw.showOnEmpty) return '';
    var target = Math.max(1, parseInt(rw.target, 10) || 1);
    var count = itemCount();
    var done = count >= target;
    var pct = Math.min(100, (count / target) * 100);
    var msg = done ? rw.after : String(rw.before || '').replace(/\{\{\s*count\s*\}\}|\[count\]/g, target - count);
    return '<div class="mgc__rw" data-done="' + done + '">' +
      '<div class="mgc__rw-msg"><p>' + msg + '</p></div>' +
      '<div class="mgc__rw-bar"><div class="mgc__rw-track">' +
        '<div class="mgc__rw-fill" style="width:' + pct + '%"></div>' +
        '<div class="mgc__rw-ms"><div class="mgc__rw-icon' + (done ? ' is-done' : '') + '">' + ICON.gift + '</div>' +
        '<div class="mgc__rw-label">' + esc(rw.label) + '</div></div>' +
      '</div></div>' +
    '</div>';
  }

  function visibleProps(props) {
    if (!props) return [];
    return Object.keys(props).filter(function (k) {
      var v = props[k];
      return k.charAt(0) !== '_' && v !== null && v !== '' && typeof v !== 'object';
    }).map(function (k) { return [k, props[k]]; });
  }

  function renderItem(item, index) {
    var line = index + 1;
    var url = item.url || '#';
    var variantText = '';
    if (!item.product_has_only_default_variant && item.options_with_values) {
      variantText = item.options_with_values
        .filter(function (o) { return o.value !== 'Default Title'; })
        .map(function (o) { return o.name + ': ' + o.value; }).join(', ');
    }
    var props = visibleProps(item.properties);
    var finalPrice = formatMoney(item.final_line_price);
    var showCompare = cfg.design.strike && item.original_line_price > item.final_line_price;
    var priceHtml = isZeroPrice(finalPrice)
      ? '<span class="mgc-tile__free">' + esc(cfg.t.free) + '</span>'
      : '<span class="mgc-tile__price">' + esc(finalPrice) + '</span>';
    var qty = item.quantity;
    var isTrash = qty <= 1;

    return '<li class="mgc__item" data-line="' + line + '">' +
      '<div class="mgc-tile"><div class="mgc-tile__content">' +
        '<a class="mgc-tile__img" href="' + esc(url) + '" tabindex="-1">' +
          (item.image ? '<img src="' + esc(imgUrl(item.image, 176)) + '" alt="' + esc(item.product_title) + '" width="88" height="88">' : '') +
        '</a>' +
        '<div class="mgc-tile__info">' +
          '<div class="mgc-tile__header"><h4 class="mgc-tile__title"><a href="' + esc(url) + '">' + esc(item.product_title) + '</a></h4></div>' +
          (variantText ? '<div class="mgc-tile__variant"><span class="mgc-tile__kv">' + esc(variantText) + '</span></div>' : '') +
          (props.length ? '<div class="mgc-tile__props">' + props.map(function (p) {
            return '<span class="mgc-tile__kv">' + esc(p[0]) + ': ' + esc(p[1]) + '</span>';
          }).join('') + '</div>' : '') +
          '<div class="mgc-tile__pricing">' +
            (showCompare ? '<s class="mgc-tile__compare">' + esc(formatMoney(item.original_line_price)) + '</s>' : '') +
            priceHtml +
          '</div>' +
          '<div class="mgc-tile__controls"><div class="mgc-qty">' +
            '<button type="button" class="mgc-qty__minus' + (isTrash ? ' is-trash' : '') + '" data-mgc-qty="' + (qty - 1) + '" aria-label="' + esc(isTrash ? cfg.t.remove : cfg.t.decrease) + '">' + (isTrash ? ICON.trash : ICON.minus) + '</button>' +
            '<input type="text" inputmode="numeric" pattern="[0-9]*" value="' + qty + '" aria-label="' + esc(cfg.t.quantity) + '" data-mgc-input>' +
            '<button type="button" class="mgc-qty__plus" data-mgc-qty="' + (qty + 1) + '" aria-label="' + esc(cfg.t.increase) + '">' + ICON.plus + '</button>' +
          '</div></div>' +
        '</div>' +
      '</div></div>' +
    '</li>';
  }

  function pickVariant(product) {
    var avail = product.variants.filter(function (v) { return v.available; });
    if (!avail.length) return null;
    if (!cfg.up.smartMatch) return avail[0];
    var wanted = {};
    (cart.items || []).forEach(function (i) {
      (i.options_with_values || []).forEach(function (o) { wanted[String(o.value).toLowerCase()] = true; });
    });
    var best = avail[0], bestScore = -1;
    avail.forEach(function (v) {
      var score = (v.options || []).reduce(function (s, val) { return s + (wanted[String(val).toLowerCase()] ? 1 : 0); }, 0);
      if (score > bestScore) { best = v; bestScore = score; }
    });
    return best;
  }

  function renderUpsellTile(p) {
    var v = pickVariant(p);
    if (!v) return '';
    var url = ROOT.replace(/\/$/, '') + '/products/' + p.handle;
    var img = (v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]);
    var single = p.variants.length === 1;
    var avail = p.variants.filter(function (x) { return x.available; });
    var compare = v.compare_at_price && v.compare_at_price > v.price;
    var select = single ? (v.title && v.title !== 'Default Title' ? '<div class="mgc-uptile__single">' + esc(v.title) + '</div>' : '') : '';
    return '<div class="mgc-car__slide"><div class="mgc-uptile" data-product="' + p.id + '">' +
      '<a class="mgc-uptile__img" href="' + esc(url) + '">' + (img ? '<img src="' + esc(imgUrl(img, 180)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
      '<div class="mgc-uptile__info">' +
        '<h4 class="mgc-uptile__title"><a href="' + esc(url) + '">' + esc(p.title) + '</a></h4>' +
        '<div class="mgc-uptile__prices">' +
          (compare && cfg.design.strike ? '<s class="mgc-uptile__compare" data-mgc-upcompare>' + esc(formatMoney(v.compare_at_price)) + '</s>' : '<s class="mgc-uptile__compare" data-mgc-upcompare hidden></s>') +
          '<span class="mgc-uptile__price" data-mgc-upprice>' + esc(formatMoney(v.price)) + '</span>' +
        '</div>' +
        select +
        '<div class="mgc-uptile__row">' +
          (single ? '' : '<select data-mgc-upvariant aria-label="' + esc(p.title) + '">' + avail.map(function (x) {
            return '<option value="' + x.id + '" data-price="' + x.price + '" data-compare="' + (x.compare_at_price || 0) + '"' + (x.id === v.id ? ' selected' : '') + '>' + esc(x.title) + '</option>';
          }).join('') + '</select>') +
          '<button type="button" class="mgc-uptile__add" data-mgc-upadd data-variant="' + v.id + '">' + esc(cfg.up.addText) + '</button>' +
        '</div>' +
      '</div>' +
    '</div></div>';
  }

  function renderUpsells() {
    if (!cfg.up.show || !upsells.length) return '';
    var max = upsells.length - 1;
    if (upIndex > max) upIndex = max;
    return '<div class="mgc-up">' +
      '<div class="mgc-up__title"><p>' + cfg.up.title + '</p></div>' +
      '<div class="mgc-car">' +
        '<button type="button" class="mgc-car__btn" data-mgc-car="-1" aria-label="' + esc(cfg.t.previous) + '"' + (upIndex <= 0 ? ' disabled' : '') + '>' + ICON.prev + '</button>' +
        '<div class="mgc-car__window"><div class="mgc-car__track" style="transform:translateX(-' + (upIndex * 100) + '%)">' +
          upsells.map(renderUpsellTile).join('') +
        '</div></div>' +
        '<button type="button" class="mgc-car__btn" data-mgc-car="1" aria-label="' + esc(cfg.t.next) + '"' + (upIndex >= max ? ' disabled' : '') + '>' + ICON.next + '</button>' +
      '</div>' +
    '</div>';
  }

  function renderFooter() {
    var n = itemCount();
    var before = cart.original_total_price > cart.total_price ? formatSubtotal(cart.original_total_price, cart.currency) : '';
    var badge = cfg.badge ? '<div class="mgc__badges"><img src="' + esc(cfg.badge) + '" alt="Trust badges" loading="lazy"></div>' : '';
    return '<div class="mgc__footer">' +
      '<div class="mgc-sub notranslate" translate="no">' +
        '<span class="mgc-sub__label">' + esc(cfg.t.subtotal) + ' <span>(' + n + ' ' + esc(n === 1 ? cfg.t.item : cfg.t.items) + ')</span></span>' +
        '<span class="mgc-sub__prices"><s>' + esc(before) + '</s><span class="mgc-sub__total">' + esc(formatSubtotal(cart.total_price, cart.currency)) + '</span></span>' +
      '</div>' +
      '<a href="' + ROOT + 'checkout" class="mgc__checkout" data-mgc-checkout>' + esc(cfg.t.checkout) + '</a>' + (cfg.pay || '') +
      badge +
    '</div>';
  }

  function render() {
    var empty = !cart.items || cart.items.length === 0;
    var scroller = view.querySelector('.mgc__body');
    var scrollTop = scroller ? scroller.scrollTop : 0;
    var html = renderHeader();
    html += '<div class="mgc__body">';
    if (cfg.ann.position !== 'bottom') html += renderAnnouncement();
    html += renderRewards(empty);
    if (empty) {
      html += '<div class="mgc__empty"><h3>' + esc(cfg.t.empty) + '</h3></div>';
    } else {
      html += '<ul class="mgc__items">' + cart.items.map(renderItem).join('') + '</ul>';
      html += renderUpsells();
    }
    if (cfg.ann.position === 'bottom') html += renderAnnouncement();
    html += '</div>';
    if (!empty) html += renderFooter();
    view.innerHTML = html;
    var newScroller = view.querySelector('.mgc__body');
    if (newScroller) newScroller.scrollTop = scrollTop;
    panel.setAttribute('aria-labelledby', 'mgc-title');
  }

  /* ---------- upsells (Shopify product recommendations, "related" intent) ---------- */
  function loadUpsells() {
    if (!cfg.up.show) { upsells = []; return Promise.resolve(); }
    if (cfg.up.manual && cfg.up.manual.length) {
      upsells = cfg.up.manual.slice(0, cfg.up.max);
      return Promise.resolve();
    }
    var ids = [];
    (cart.items || []).forEach(function (i) { if (ids.indexOf(i.product_id) === -1) ids.push(i.product_id); });
    if (!ids.length) { upsells = []; return Promise.resolve(); }
    var inCart = {};
    (cart.items || []).forEach(function (i) { inCart[i.product_id] = true; });
    return Promise.all(ids.slice(0, 5).map(function (id) {
      if (recCache[id]) return Promise.resolve(recCache[id]);
      return _fetch(ROOT + 'recommendations/products.json?product_id=' + id + '&intent=' + encodeURIComponent(cfg.up.intent) + '&limit=10')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { recCache[id] = j.products || []; return recCache[id]; })
        .catch(function () { return []; });
    })).then(function (lists) {
      var seen = {}, out = [];
      var maxLen = Math.max.apply(null, lists.map(function (l) { return l.length; }).concat([0]));
      for (var i = 0; i < maxLen; i++) {
        lists.forEach(function (l) {
          var p = l[i];
          if (!p || seen[p.id]) return;
          if (!cfg.up.showInCart && inCart[p.id]) return;
          if (!p.variants || !p.variants.some(function (v) { return v.available; })) return;
          seen[p.id] = true; out.push(p);
        });
      }
      upsells = out.slice(0, cfg.up.max);
    });
  }

  /* ---------- cart actions ---------- */
  function refresh(opts) {
    opts = opts || {};
    return api('cart.js').then(function (c) {
      cart = c;
      render();
      if (opts.notify) notifyTheme();
      return loadUpsells().then(render);
    }).catch(function () {});
  }

  function changeLine(line, quantity) {
    if (busy) return;
    busy = true;
    var li = view.querySelector('.mgc__item[data-line="' + line + '"] .mgc-tile');
    if (li) li.classList.add('is-loading');
    api('cart/change.js', { line: line, quantity: Math.max(0, quantity) })
      .then(function (c) { cart = c; render(); notifyTheme(); return loadUpsells().then(render); })
      .catch(function (err) {
        if (li) li.classList.remove('is-loading');
        if (err && err.description) alert(err.description);
        return refresh();
      })
      .then(function () { busy = false; });
  }

  function addVariant(id, btn) {
    if (btn) btn.classList.add('is-loading');
    api('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
      .then(function () { return refresh({ notify: true }); })
      .catch(function (err) { if (err && err.description) alert(err.description); })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  /* ---------- open / close ---------- */
  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    render();
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mgc-lock');
    setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) {} }, 50);
    if (!upsells.length && cart.items && cart.items.length) loadUpsells().then(render);
  }

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mgc-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- events inside drawer ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-mgc-close]') || t.classList.contains('mgc__backdrop')) { e.preventDefault(); close(); return; }
    var q = t.closest('[data-mgc-qty]');
    if (q) {
      var li = q.closest('.mgc__item');
      changeLine(Number(li.dataset.line), Number(q.dataset.mgcQty));
      return;
    }
    var nav = t.closest('[data-mgc-car]');
    if (nav) {
      upIndex = Math.max(0, Math.min(upsells.length - 1, upIndex + Number(nav.dataset.mgcCar)));
      var track = view.querySelector('.mgc-car__track');
      if (track) track.style.transform = 'translateX(-' + (upIndex * 100) + '%)';
      var btns = view.querySelectorAll('[data-mgc-car]');
      if (btns[0]) btns[0].disabled = upIndex <= 0;
      if (btns[1]) btns[1].disabled = upIndex >= upsells.length - 1;
      return;
    }
    var add = t.closest('[data-mgc-upadd]');
    if (add) { addVariant(add.dataset.variant, add); return; }
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-mgc-input]')) {
      var li = t.closest('.mgc__item');
      var val = parseInt(t.value, 10);
      if (isNaN(val) || val < 0) val = 0;
      changeLine(Number(li.dataset.line), val);
    }
    if (t.matches('[data-mgc-upvariant]')) {
      var tile = t.closest('.mgc-uptile');
      var opt = t.options[t.selectedIndex];
      var price = Number(opt.dataset.price), cmp = Number(opt.dataset.compare);
      tile.querySelector('[data-mgc-upadd]').dataset.variant = t.value;
      tile.querySelector('[data-mgc-upprice]').textContent = formatMoney(price);
      var c = tile.querySelector('[data-mgc-upcompare]');
      if (cmp > price && cfg.design.strike) { c.textContent = formatMoney(cmp); c.hidden = false; } else { c.hidden = true; }
    }
  });

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    if (e.key === 'Enter' && e.target.matches('[data-mgc-input]')) { e.preventDefault(); e.target.blur(); }
  });

  /* ---------- global triggers ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mg-cart-open], a[href="' + ROOT + 'cart"], a[href="/cart"]');
    if (!trigger || root.contains(trigger)) return;
    if (cfg.template === 'cart') return;
    e.preventDefault();
    open();
  }, true);

  /* Theme events (Horizon dispatches cart:update after add-to-cart / cart changes) */
  document.addEventListener('cart:update', function (e) {
    var d = e.detail || {};
    if (d.sourceId === SOURCE || (d.data && d.data.source === SOURCE)) return;
    refresh();
  });

  /* Intercept any add-to-cart (theme forms, quick add, other apps) to open the drawer, like UpCart does */
  var pendingOpen = null;
  function onAdded() {
    clearTimeout(pendingOpen);
    pendingOpen = setTimeout(function () {
      refresh({ notify: true }).then(function () { if (cfg.openOnAdd) open(); });
    }, 60);
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch(input, init);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) { if (r && r.ok) onAdded(); }).catch(function () {});
    } else if (/\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) { if (r && r.ok) setTimeout(refresh, 60); }).catch(function () {});
    }
    return p;
  };

  /* Non-AJAX product forms (fallback): submit via AJAX so the drawer opens instead of redirecting */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || !/\/cart\/add(\?|$)/.test(form.action)) return;
    if (form.closest('product-form-component') || e.defaultPrevented) return;
    e.preventDefault();
    _fetch(ROOT + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { if (r.ok) onAdded(); });
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.MargotCart = { open: open, close: close, refresh: refresh, getCart: function () { return cart; } };

  render();
})();
